import InativacaoLoteStatusItemModel from "./InativacaoLoteStatusItemModel";

export default class InativacaoLoteStatusModel {
  constructor(
    {
      id,
      dataInicio,
      dataFim,
      totalRegistros,
      totalRegistrosProcessados,
      totalRegistrosProcessadosComSucesso,
      confirmado,
      processando,
      finalizado,
      finalizadoComErro,
      itens,
    } = new Object()
  ) {
    this._id = id;
    this._dataInicio = dataInicio;
    this._dataFim = dataFim;
    this._totalRegistros = totalRegistros;
    this._totalRegistrosProcessados = totalRegistrosProcessados;
    this._totalRegistrosProcessadosComSucesso =
      totalRegistrosProcessadosComSucesso;
    this._confirmado = confirmado;
    this._processando = processando;
    this._finalizado = finalizado;
    this._finalizadoComErro = finalizadoComErro;
    // usa o setter (não atribuição direta a _itens) para garantir a conversão para
    // InativacaoLoteStatusItemModel já na construção.
    this.itens = itens;
  }

  get id() {
    return this._id;
  }

  set id(id = null) {
    this._id = id;
  }

  get dataInicio() {
    return this._dataInicio || null;
  }

  set dataInicio(dataInicio = null) {
    this._dataInicio = dataInicio;
  }

  get dataFim() {
    return this._dataFim || null;
  }

  set dataFim(dataFim = null) {
    this._dataFim = dataFim;
  }

  get totalRegistros() {
    return this._totalRegistros || 0;
  }

  set totalRegistros(totalRegistros = null) {
    this._totalRegistros = totalRegistros;
  }

  get totalRegistrosProcessados() {
    return this._totalRegistrosProcessados || 0;
  }

  set totalRegistrosProcessados(totalRegistrosProcessados = null) {
    this._totalRegistrosProcessados = totalRegistrosProcessados;
  }

  get totalRegistrosProcessadosComSucesso() {
    return this._totalRegistrosProcessadosComSucesso || 0;
  }

  set totalRegistrosProcessadosComSucesso(
    totalRegistrosProcessadosComSucesso = null
  ) {
    this._totalRegistrosProcessadosComSucesso =
      totalRegistrosProcessadosComSucesso;
  }

  get confirmado() {
    return this._confirmado || false;
  }

  set confirmado(confirmado = false) {
    this._confirmado = confirmado;
  }

  get processando() {
    return this._processando || false;
  }

  set processando(processando = false) {
    this._processando = processando;
  }

  get finalizado() {
    return this._finalizado || false;
  }

  set finalizado(finalizado = false) {
    this._finalizado = finalizado;
  }

  get finalizadoComErro() {
    return this._finalizadoComErro || false;
  }

  set finalizadoComErro(finalizadoComErro = false) {
    this._finalizadoComErro = finalizadoComErro;
  }

  get itens() {
    return this._itens || new Array();
  }

  set itens(itens = null) {
    if (!Array.isArray(itens)) {
      this._itens = new Array();
      return;
    }
    this._itens = itens.map((item) =>
      item instanceof InativacaoLoteStatusItemModel
        ? item
        : new InativacaoLoteStatusItemModel(item)
    );
  }
}
